<template>
  <div class="home" style="height:100vh;overflow-y: auto;">
    <el-backtop target=".home"></el-backtop>

    <el-dialog
      title="学习须知"
      :visible.sync="loginAnnouncementVisible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      center>
      <div style="padding: 20px; text-align: left; line-height: 1.8;">
        <h3 style="color: #1c4e8a; margin-bottom: 15px;">{{ announcement.title }}</h3>
        <p style="color: #666; text-indent: 2em; margin-bottom: 10px;">{{ announcement.content }}</p>
        <div style="background: #fdf6ec; padding: 18px; border-radius: 8px; margin-top: 20px; border: 1px solid #faecd8;">
          <h4 style="color: #E6A23C; margin-bottom: 12px; font-size: 15px;">重要提示</h4>
          <ul style="color: #666; padding-left: 20px; line-height: 2;">
            <li style="margin-bottom: 8px; font-weight: 500; color: #e6a03c;">必须本人学习，否则学习无效，相关责任由学员自行承担</li>
            <li style="margin-bottom: 8px;">建议使用谷歌浏览器、Edge浏览器，防止进度保存失败</li>
            <li style="margin-bottom: 8px;">系统只记录实际学习时间，快进无效</li>
            <li>请保持摄像头正常开启，学习过程系统会随机抓拍</li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmAnnouncement" size="medium">我知道了</el-button>
      </span>
    </el-dialog>

    <Header/>
    <Hero/>

    <div class="home-main">
      <!-- 第一行：左课程 | 右登录/注册 -->
      <div class="home-row">
        <div class="col-course">
          <Special :categories="subList" />
        </div>

        <div class="col-side">
          <div class="side-card" :class="{ 'side-card-fill': !isLOgin }">
            <div class="side-header">
              <span class="side-title">{{ isLOgin ? '用户中心' : '用户登录' }}</span>
            </div>

            <!-- 已登录 -->
            <template v-if="isLOgin">
              <div class="user-box">
                <div class="user-avatar">{{ (realName || name || '学员').slice(0, 1) }}</div>
                <div class="user-meta">
                  <div class="user-name">{{ realName || name || '学员' }}</div>
                  <div class="user-sub" v-if="name">账号：{{ name }}</div>
                </div>
              </div>
              <div class="side-actions">
                <el-button type="primary" class="side-btn" @click="goProfile">个人中心</el-button>
                <el-button class="side-btn side-btn-plain" @click="goLogout">退出登录</el-button>
              </div>
            </template>

            <!-- 未登录：登录/注册输入框 -->
            <template v-else>
              <el-form
                ref="loginForm"
                :model="loginForm"
                :rules="loginRules"
                label-width="0px"
                autocomplete="off"
                @submit.native.prevent
              >
                <el-form-item prop="username">
                  <el-input
                    v-model="loginForm.username"
                    prefix-icon="el-icon-user"
                    placeholder="请输入账号"
                    name="rn-home-user"
                    autocomplete="off"
                  />
                </el-form-item>
                <el-form-item prop="password">
                  <el-input
                    type="password"
                    v-model="loginForm.password"
                    prefix-icon="el-icon-lock"
                    placeholder="请输入密码"
                    name="rn-home-pass"
                    autocomplete="new-password"
                    @keyup.enter.native="handleLogin"
                  />
                </el-form-item>
              </el-form>
              <VerifySlider
                ref="slider"
                class="verify-slider"
                @success="sliderVerified = true"
              />
              <div class="side-btn-row">
                <el-button
                  type="primary"
                  :loading="loading"
                  class="side-btn"
                  @click="handleLogin"
                >登 录</el-button>
                <el-button
                  class="side-btn side-btn-white"
                  @click="goRegister"
                >注 册</el-button>
              </div>
            </template>
          </div>

          <!-- 二维码 -->
          <div class="qr-card">
            <div class="qr-list">
              <div class="qr-item">
                <div class="qr-box">
                  <el-image
                    class="qr-img"
                    :src="qrMiniProgram"
                    :preview-src-list="[qrMiniProgram]"
                    preview-teleported
                    fit="contain"
                  />
                </div>
                <span class="qr-label">小程序</span>
              </div>
              <div class="qr-item">
                <div class="qr-box qr-placeholder">
                  <i class="el-icon-picture-outline"></i>
                </div>
                <span class="qr-label">公众号</span>
              </div>
              <div class="qr-item">
                <div class="qr-box qr-placeholder">
                  <i class="el-icon-picture-outline"></i>
                </div>
                <span class="qr-label">交流群</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第二行：通知公告 | 常见问题 -->
      <div class="home-row">
        <div class="col-bottom">
          <Notice />
        </div>
        <div class="col-bottom">
          <div class="faq-card">
            <div class="card-header">
              <span class="card-title">常见问题</span>
              <span class="card-more">更多 &gt;</span>
            </div>
            <div class="faq-list">
              <div class="faq-item" v-for="q in faqList" :key="q">
                <span class="faq-dot"></span>
                <span>{{ q }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer/>
  </div>
</template>

<script>
import Header from "./header/index";
import Hero from "./hero/index";
import Notice from "./notice/index"
import Special from "./specialSubject/index";
import Footer from "./footer";
import { getCategory } from '@/api/home'
import { getToken } from '@/utils/auth'
import { mapGetters } from "vuex";
import VerifySlider from "@/components/VerifySlider/index";
import qrMiniProgram from "@/assets/xiaochengxu.png";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Home",
  components: {
    Header,
    Hero,
    Notice,
    Special,
    Footer,
    VerifySlider
  },
  data() {
    return {
      subList:[],
      userinfo: {},
      loading: false,
      sliderVerified: false,
      qrMiniProgram,
      loginForm: {
        username: "",
        password: "",
      },
      loginRules: {
        username: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { min: 5, max: 18, message: "长度在 5 到 18 个字符", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 5, max: 18, message: "长度在 5 到 18 个字符", trigger: "blur" },
        ],
      },
      loginAnnouncementVisible: false,
      announcement: {
        title: '学习须知',
        content: '为了防止进度保存失败，建议使用谷歌浏览器、Edge浏览器进行学习，系统只记录实际学习时间，快进无效！'
      },
      faqList: [
        "如何注册账号并完成学员报名？",
        "在线学习和考试的流程是什么？",
        "学时如何认定？证书如何领取？",
        "忘记密码或账号被锁定怎么办？",
        "课程学习遇到卡顿如何处理？",
      ],
    };
  },
  created() {
    this.$root.$on("home-show-buy", this.showBuyTab);
    this.checkLoginAnnouncement();
    this.getCategoryList()
  },
  mounted() {
    // 从其他页面带 ?tab=buy 进来时，直接展示购买列表
    if (this.$route.query.tab === "buy") this.showBuyTab();
  },
  beforeDestroy() {
    this.$root.$off("home-show-buy", this.showBuyTab);
  },
  computed: {
    isLOgin: function() {
      return getToken()
    },
    ...mapGetters(["name", "realName"]),
  },
  methods: {
    // 滚动到「课程购买」区域
    showBuyTab() {
      this.$nextTick(() => {
        const el = document.querySelector(".course-section");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    },
    checkLoginAnnouncement() {
      if (!getToken()) return;
      const hasShown = sessionStorage.getItem('loginAnnouncementShown');
      if (!hasShown) {
        setTimeout(() => {
          this.loginAnnouncementVisible = true;
        }, 500);
      }
    },
    confirmAnnouncement() {
      sessionStorage.setItem('loginAnnouncementShown', 'true');
      this.loginAnnouncementVisible = false;
    },
    async getCategoryList(){
      try {
        const res = await getCategory()
        this.subList = res.data
      } catch (error) {
        console.log(error);
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) return false;
        if (!this.sliderVerified) {
          this.$message.warning("请先按住滑块完成验证");
          return false;
        }
        this.loading = true;
        sessionStorage.removeItem("loginAnnouncementShown");
        this.$store
          .dispatch("user/login", this.loginForm)
          .then(() => {
            this.loading = false;
            this.$message.success("登录成功");
            window.location.reload();
          })
          .catch(() => {
            this.loading = false;
            this.sliderVerified = false;
            if (this.$refs.slider) this.$refs.slider.reset();
          });
      });
    },
    goRegister() {
      let routeData = this.$router.resolve({ name: "register" });
      window.open(routeData.href, "_blank");
    },
    goProfile() {
      let routeData = this.$router.resolve({ name: "profile" });
      window.open(routeData.href, "_blank");
    },
    goLogout() {
      sessionStorage.removeItem("loginAnnouncementShown");
      localStorage.removeItem("loginAnnouncementShown");
      this.$store.dispatch("user/logout");
      this.$message.success("退出成功");
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  height: 100vh;
  background: #f2f4f7;
  position: relative;
  overflow-y: auto;

  // 右侧滚动条美化
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c8d3e0;
    border-radius: 4px;

    &:hover { background: #a9b8cc; }
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  scrollbar-width: thin;
  scrollbar-color: #c8d3e0 transparent;
}

.home-main {
  padding: 30px 20px 20px;
}

.home-row {
  display: flex;
  gap: 24px;
  align-items: stretch;
}

.home-row + .home-row {
  margin-top: 24px;
}

.col-course {
  flex: 1;
  min-width: 0;
  display: flex;
}

.col-course > * {
  width: 100%;
}

.col-side {
  width: 340px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.col-side > * {
  width: 100%;
}

.col-bottom {
  flex: 1;
  min-width: 0;
  display: flex;
}

.col-bottom > * {
  width: 100%;
}

// 通知公告自带下边距，去掉以便与常见问题对齐
.col-bottom ::v-deep .notice-section {
  margin-bottom: 0;
}

// ====================== 右侧登录 / 用户卡片 ======================
.side-card {
  background: #fff;
  border: 1px solid #e3e8ef;
  border-radius: 2px;
  padding: 24px 22px;
  display: flex;
  flex-direction: column;

  ::v-deep .el-form-item {
    margin-bottom: 16px;
  }

  ::v-deep .el-input__inner {
    height: 42px;
    line-height: 42px;
    border-radius: 2px;
    background: #f7f9fc;

    &:focus {
      border-color: #1c4e8a;
    }
  }

  ::v-deep .verify-slider {
    margin-bottom: 20px;
  }
}

// ====================== 二维码 ======================
.qr-card {
  background: #fff;
  border: 1px solid #e3e8ef;
  border-radius: 2px;
  padding: 18px 16px;
}

.qr-list {
  display: flex;
  gap: 10px;
}

.qr-item {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.qr-box {
  width: 100%;
  aspect-ratio: 1 / 1;
  border: 1px solid #e3e8ef;
  border-radius: 2px;
  background: #f7f9fc;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
}

.qr-img {
  width: 100%;
  height: 100%;
  display: block;
  cursor: zoom-in;
}

.qr-placeholder {
  border-style: dashed;
  color: #b6c2d1;
  font-size: 20px;
}

.qr-label {
  font-size: 12px;
  color: #5b6b7f;
}

.side-header {
  padding-bottom: 14px;
  margin-bottom: 18px;
  border-bottom: 1px solid #f0f0f0;

  .side-title {
    font-size: 20px;
    font-weight: 700;
    color: #222;
    position: relative;
    padding-left: 14px;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 20px;
      background: #1c4e8a;
      border-radius: 0;
    }
  }
}

// 未登录时：登录卡片撑满，使右侧与左侧课程区域等高
.side-card-fill {
  flex: 1;

  .side-btn-row {
    margin-top: auto;
  }
}

.side-btn-row {
  display: flex;
  gap: 12px;

  .side-btn {
    flex: 1;
    width: auto;
    min-width: 0;
  }

  ::v-deep .el-button + .el-button {
    margin-left: 0;
  }
}

.side-btn {
  width: 100%;
  height: 42px;
  padding: 0;
  border-radius: 2px;
  font-size: 15px;
  letter-spacing: 4px;
  background: #1c4e8a;
  border: none;

  &:hover {
    background: #123a68;
  }
}

// 注册按钮：白底
.side-btn-white {
  background: #fff;
  color: #1c4e8a;
  border: 1px solid #c3d8ee;

  &:hover {
    background: #f2f7fc;
    color: #123a68;
    border-color: #1c4e8a;
  }
}

.side-btn-plain {
  background: #fff;
  color: #1c4e8a;
  border: 1px solid #c3d8ee;
  letter-spacing: 0;

  &:hover {
    background: #f2f7fc;
    color: #123a68;
  }
}

.side-actions {
  display: flex;
  gap: 12px;
  padding-top: 18px;

  .side-btn {
    flex: 1;
    width: auto;
    min-width: 0;
  }

  ::v-deep .el-button + .el-button {
    margin-left: 0;
  }
}

.user-box {
  display: flex;
  align-items: center;
  padding: 4px 0 18px;
  border-bottom: 1px solid #f0f0f0;
}

.user-avatar {
  width: 44px;
  height: 44px;
  flex: none;
  border-radius: 2px;
  background: #eef3f9;
  border: 1px solid #d6e2ef;
  color: #1c4e8a;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.user-meta {
  min-width: 0;
}

.user-name {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
}

.user-sub {
  font-size: 12px;
  color: #8a94a6;
  margin-top: 2px;
}

// ====================== 常见问题 ======================
.faq-card {
  background: #fff;
  border-radius: 2px;
  border: 1px solid #e3e8ef;
  box-shadow: 0 1px 2px rgba(20, 40, 80, 0.04);
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;

    .card-title {
      font-size: 16px;
      font-weight: 700;
      color: #222;
      position: relative;
      padding-left: 14px;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 16px;
        background: #1c4e8a;
        border-radius: 0;
      }
    }

    .card-more {
      font-size: 12px;
      color: #999;
      cursor: pointer;
      &:hover { color: #1c4e8a; }
    }
  }

  .faq-list {
    .faq-item {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      padding: 10px 0;
      font-size: 13px;
      color: #555;
      cursor: pointer;
      border-bottom: 1px dashed #f0f0f0;

      &:last-child { border-bottom: none; }
      &:hover { color: #1c4e8a; }

      .faq-dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #1c4e8a;
        flex-shrink: 0;
        margin-top: 6px;
      }
    }
  }
}

@media (max-width: 992px) {
  .home-row { flex-direction: column; }
  .col-side { width: 100%; }
}
</style>
